export default {
  item: [
    {
      order: 1,
      label: 'Item ID',
      dataKey: 'item.id',
      width: 80
    },
    {
      order: 2,
      label: 'Item Name',
      dataKey: 'item.name',
      width: 200
    }
  ],
  picklist: [
    {
      order: 3,
      label: 'Picklist ID',
      dataKey: 'picklist.id',
      width: 100
    },
    {
      order: 4,
      label: 'Picklist Name',
      dataKey: 'picklist.name',
      width: 200
    }
  ],
  client: [
    {
      order: 5,
      label: 'Guest ID',
      dataKey: 'client.id',
      width: 80
    },
    {
      order: 6,
      label: 'Guest Name',
      dataKey: 'client.name',
      width: 200
    }
  ],
  trackingMethod: [
    {
      order: 7,
      label: 'Tracking Method ID',
      dataKey: 'trackingMethod.id',
      width: 150
    },
    {
      order: 8,
      label: 'Tracking Method',
      dataKey: 'trackingMethod.label',
      width: 200
    }
  ],
  reservationStatus: {
    order: 11,
    label: 'Reservation Status',
    dataKey: 'reservationStatus',
    width: 150
  },
  reservationCount: {
    order: 10,
    label: 'Reservation Count',
    dataKey: 'reservationCount',
    width: 150
  },
  itemQtySum: {
    order: 9,
    label: 'Item Quantity',
    dataKey: 'itemQtySum',
    width: 140
  }
};
